import { useEffect } from "react";
import { useCarFilterStore } from "@/store/carFilterStore";

interface BrandSidebarProps {
  activeBrand: number;
  onBrandChange: (id: number) => void;
}

const BRAND_ICONS: Record<string, string> = {
  "特斯拉": "ri-charging-pile-line",
  "比亚迪": "ri-charging-pile-line",
};

export default function BrandSidebar({ activeBrand, onBrandChange }: BrandSidebarProps) {
  const brands = useCarFilterStore((state) => state.brands);
  const isLoading = useCarFilterStore((state) => state.isLoading);
  const loadFilters = useCarFilterStore((state) => state.loadFilters);

  useEffect(() => {
    loadFilters();
  }, [loadFilters]);

  // 全部品牌项在最前面
  const allBrands = [{ brand: "全部", count: 0 }, ...brands];

  return (
    <div
      className="flex-shrink-0 bg-white flex flex-col overflow-y-auto sticky"
      style={{
        width: 72,
        borderRight: "1px solid #F0F0F0",
        top: 196,
        maxHeight: "calc(100vh - 196px)",
      }}
    >
      {isLoading ? (
        <div className="flex items-center justify-center py-4">
          <span className="text-xs text-gray-400">加载中...</span>
        </div>
      ) : (
        allBrands.map((item, index) => (
          <button
            key={item.brand}
            onClick={() => onBrandChange(index)}
            className="flex flex-col items-center py-3.5 px-1 cursor-pointer transition-all relative"
            style={{
              background: activeBrand === index ? "#EFF6FF" : "transparent",
              borderRight: activeBrand === index ? "3px solid #1E3A8A" : "3px solid transparent",
            }}
          >
            <div
              className="w-9 h-9 flex items-center justify-center rounded-xl mb-1"
              style={{
                background: activeBrand === index ? "#1E3A8A" : "#F3F4F6",
              }}
            >
              <i
                className={BRAND_ICONS[item.brand] || "ri-car-line"}
                style={{
                  fontSize: 16,
                  color: activeBrand === index ? "#fff" : "#6B7280",
                }}
              />
            </div>
            <span
              className="text-center leading-tight truncate w-full px-1"
              style={{
                fontSize: 10,
                color: activeBrand === index ? "#1E3A8A" : "#6B7280",
                fontWeight: activeBrand === index ? 700 : 400,
              }}
              title={item.brand}
            >
              {item.brand}
            </span>
          </button>
        ))
      )}
    </div>
  );
}
